var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('SystemWideSearch'),_c('ShareCardReport',{attrs:{"number_of_high_risk_issues":23,"organization_name":'Amsterdam',"report_id":420,"twitter_username":'AmsterdamNL'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }